import { render } from "./Parallax.vue?vue&type=template&id=6b21f176&scoped=true"
import script from "./Parallax.vue?vue&type=script&lang=js"
export * from "./Parallax.vue?vue&type=script&lang=js"

import "./Parallax.vue?vue&type=style&index=0&id=6b21f176&lang=scss&scoped=true"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b21f176"]])

export default __exports__